import { useRuntimeConfig } from '#imports'
import type { H3Event } from 'h3'

import type { Market } from '@backmarket/http-api'

import { getMarkets } from '../utils/getMarkets'

import { getRequestCountryCode } from './getRequestCountryCode'

/** Get market from H3 event. */
export function getRequestMarket(event: H3Event): Market {
  const config = useRuntimeConfig(event)
  const enableEsUsLocale = Boolean(config.public.FF_ENABLE_ES_US_LOCALE)

  const markets = getMarkets(enableEsUsLocale)

  const countryCode = getRequestCountryCode(event)

  return markets[countryCode]
}
